export default __webpack_public_path__ + "static/maduraLogo-5877f563076e9857a9763643b83271db.png";